import React, { useState, useEffect } from 'react';
import { Typography, Box, useMediaQuery, useTheme, Stack } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ChatIcon from '@mui/icons-material/Chat';

/*
import { MuiChat } from 'chat-ui-react/dist/cjs/mui/MuiChat.js'; 
import { MuiMessage } from 'chat-ui-react/dist/cjs/mui/MuiMessage.js'; 
import { MuiTextInput } from 'chat-ui-react/dist/cjs/mui/MuiTextInput.js'; 
*/
import { MuiChat } from './chatUiReact/qeedist/cjs/mui/MuiChat.js'; 
import { MuiMessage } from './chatUiReact/qeedist/cjs/mui/MuiMessage.js'; 
import { MuiTextInput } from './chatUiReact/qeedist/cjs/mui/MuiTextInput.js'; 
import { resolveChatUiLabels } from './chatUiReact/qeedist/cjs/mui/chatUiLabels.js';

import { themeV4, themeV5 } from '../core/theme.js';

function resolvePendingProgressSteps(questionValue, chatConfigName, labels) {
	const question = String(questionValue || '').trim().toLowerCase();
	const configName = String(chatConfigName || '').trim().toLowerCase();
	const isDocumentationOnly = configName === 'synapcus-chat-qalgo1';
	const isHelpIntent = /wie\s+(erstelle|mache|funktioniert)|wo\s+finde|anleitung|hilfe|help|how\s+(do|can)|what\s+is|was\s+ist|cum\s+(fac|pot)|ajutor/.test(question);

	let dataContextStep = '';
	if (/zeitnachweis|arbeitszeit|timesheet|time\s*record|tim\b|ore\s+lucrate/.test(question)) {
		dataContextStep = labels.progressTimeRecords;
	} else if (/urlaub|abwesen|feiertag|resturlaub|vacation|leave|holiday|concediu|rqa/.test(question)) {
		dataContextStep = labels.progressLeaveHr;
	} else if (/projekt|project|proiect|prj\b/.test(question)) {
		dataContextStep = labels.progressProjects;
	} else if (/aktivität|aktivitaet|activity|activitate|aufgabe|task|sarcin|sac\b/.test(question)) {
		dataContextStep = labels.progressActivities;
	}

	if (isDocumentationOnly || isHelpIntent) {
		return [labels.progressHelpLocate, labels.progressHelpReview, labels.progressHelpCompose].filter(Boolean);
	}
	if (dataContextStep) {
		return [labels.progressDataConnect, dataContextStep, labels.progressDataInterpret].filter(Boolean);
	}
	return [labels.progressGeneralUnderstand, labels.progressGeneralCheck, labels.progressGeneralCompose].filter(Boolean);
}

function QeeMuiChat({ chatController, actReq, ...props }) {
	const [isInitializingChat, setIsInitializingChat] = useState(true);
    const [waitingForResponse, setWaitingForResponse] = useState(false);
	const [pendingStatus, setPendingStatus] = useState('');
	
	const theme = useTheme(); // This uses the theme from the context
	const isMobileViewport = useMediaQuery('(max-width:599.95px)');

    const msgRef = React.useRef(null);

	useEffect(() => {
		if (!waitingForResponse) {
			setPendingStatus('');
			return undefined;
		}

		const labels = resolveChatUiLabels(props.supportLanguage, props.chatUiLabels);
		const latestUserMessage = [...chatController.getMessages()]
			.reverse()
			.find(message => message && message.self && typeof message.content === 'string');
		const configName = chatController.chatConfig?.chat_cfg_name || chatController.chatConfig?.chatConfig || '';
		const steps = resolvePendingProgressSteps(latestUserMessage?.content, configName, labels);
		if (steps.length === 0) return undefined;
		let step = 0;
		setPendingStatus(steps[step]);
		const timer = window.setInterval(() => {
			step = Math.min(step + 1, steps.length - 1);
			setPendingStatus(steps[step]);
		}, 1600);

		return () => window.clearInterval(timer);
	}, [waitingForResponse, chatController, props.supportLanguage, props.chatUiLabels]);

    const scroll = React.useCallback(() => {
        //alert( msgRef.current)
        if (msgRef.current) {
            msgRef.current.scrollTop = msgRef.current.scrollHeight; // msgRef.current.scrollIntoView(true);
        }
    }, [msgRef]);  

    useEffect(() => {
        var es = document.querySelectorAll('.MuiBox-root.css-18r6i10');
        es.forEach(e => {
            e.style.background = '#30b33e59';
        });
        es = document.querySelectorAll('.MuiBox-root.css-d0zsf2');
        es.forEach(e => {
            e.style['box-shadow'] = 'none';
			e.style['border'] = '1px solid lightgrey';
        });	
		es = document.querySelectorAll('.MuiBox-root.css-1v6vqto p');
        es.forEach(e => {
            e.style['box-shadow'] = 'none';
			e.style['color'] = 'white';
        });	
		es = document.querySelectorAll('.MuiBox-root.css-m3n9sn');
        es.forEach(e => {
            e.style['background-color'] = themeV4.palette ? themeV4.palette.primary.main : 'darkgrey';
        });			
		es = document.querySelectorAll('.MuiBox-root.css-m3n9sn p');
        es.forEach(e => {
			e.style['color'] = 'white';
        });

		es = document.querySelectorAll('.css-9l3uo3 p');
		console.log( 'es for font-size: ', es);
        es.forEach(e => {
			console.log( 'Change font-size for: ', e);
			e.style['font-size'] = 'none';
        });

		
		es = document.querySelectorAll('.MuiButtonBase-root.css-1p4aeya-MuiButtonBase-root-MuiButton-root');
		es.forEach(e => {
			const icon = e.querySelector('.icon');
			//if (icon) icon.remove();
			//e.textContent = 'Senden';
			//e.style.color = 'green';
		});
		
		// the container for select-questions
		//es = document.querySelectorAll('.MuiBox-root.css-1gyrids, .MuiBox-root.css-ix91r1');
		es = document.querySelectorAll('.qeeChatButtonContainer, .qeeQuickQuestionContainer');
			es.forEach(e => {	
			// Ensure the container allows for flex wrapping
			e.style.display = 'flex';
			e.style.flexWrap = 'wrap'; // Enable wrapping
			e.style.alignItems = 'flex-end'; // Adjust alignment as needed
			e.style.gap = '10px'; // Add some space between items
			e.style.width = '100%';
			e.style.minWidth = '0';
			e.style.boxSizing = 'border-box';

			// Adjust the styles for spans inside the button, making them invisible/transparent
			e.querySelectorAll('span').forEach(span => {
				span.style.opacity = 0;
			});

			// Apply styles to each button within the container
			e.querySelectorAll('button').forEach(button => {
				if (button.classList.contains('qeeSupportSecondaryButton')) {
					button.style.setProperty('background-color', themeV4.palette.primary.contrastText, 'important');
					button.style.setProperty('color', themeV4.palette.primary.main, 'important');
					button.style.setProperty('border-color', themeV4.palette.primary.main, 'important');
					button.style.setProperty('border-width', '1px', 'important');
					button.style.setProperty('border-style', 'solid', 'important');
					return;
				}
				// Basic button styles
				button.style.textTransform = 'none';
				button.style.setProperty('background-color', themeV4.palette ? themeV4.palette.primary.main : 'darkgrey', 'important');
				button.style.setProperty('color', 'white', 'important'); // Ensuring text color is white with important flag
				button.style.width = 'fit-content';
				button.style.maxWidth = '100%';
				button.style.boxSizing = 'border-box';
				button.style.setProperty('margin-left', '0', 'important');
				button.style.borderRadius = '16px';
				//button.style.marginBottom = '20px'; // Adjust if needed for layout

				// Specific styles for buttons also marked as quick questions
				if (button.classList.contains('qeeQuickQuestion')) {
					button.style.setProperty('background-color', 'white', 'important'); // Setting background to white
					button.style.setProperty('color', themeV4.palette ? themeV4.palette.primary.main : 'darkgrey', 'important'); // Text color set to primary or dark grey
					button.style.setProperty('height', 'auto', 'important');
					button.style.setProperty('min-height', '32px', 'important');
					button.style.setProperty('white-space', 'normal', 'important');
					button.style.setProperty('line-height', '1.3', 'important');
					button.style.setProperty('overflow-wrap', 'anywhere', 'important');
					button.style.borderColor = themeV4.palette ? themeV4.palette.primary.main : 'darkgrey'; // Border color matches text
					button.style.borderWidth = '2px';
					button.style.borderStyle = 'solid';
				}
			});			
		});					
					
    }, [chatController.getMessages().length, waitingForResponse, isInitializingChat]);

    useEffect(() => {
		const handleSelfMessage = (message) => {
			console.log('handleSelfMessage message', message);
			if (!Array.isArray(message) || message.length === 0) {
				setWaitingForResponse(false);
				return;
			}

			// for P2P chats just return
			if( chatController.chatConfig?.isP2P) {
				scroll();
				return;
			}

			if (message[message.length - 1] && message[message.length - 1].self) {
				chatController.setActionRequest({ type: null });
				setWaitingForResponse(true);
				scroll();
			} else {
				
				let quickQuestions = null;
				/*
				// Loop backwards to find the first message with quickQuestions
				for (let i = message.length - 1; i >= 0; i--) {
					if (message[i] && message[i].quickQuestions) {
						quickQuestions = message[i].quickQuestions;
						break; // Break the loop once we find the first element with quickQuestions
					}
				}
				*/
				quickQuestions = message[message.length - 1].quickQuestions;
				if (quickQuestions) {
					chatController.setActionRequest({ type: 'text', always: true, self: true, quickQuestions: quickQuestions });
				} else {
					chatController.setActionRequest({ type: 'text', always: true, self: true });
				}

				setWaitingForResponse(false);
				scroll();
			}
		};

		// global set (set from the parent component)
		setIsInitializingChat(false);			
		
        // Add a listener for self messages
        chatController.addOnMessagesChanged(handleSelfMessage);

        // Cleanup the listener when the component unmounts
        return () => {
            chatController.removeOnMessagesChanged(handleSelfMessage);
        };  
    }, [chatController]); 
  
    function renderWelcomeHeader() {
        return (
            <Box textAlign="center" marginTop={2} marginBottom={2} mx="auto">
				{ !chatController.chatConfig?.isP2P &&
					<>
					<Stack
						direction="row"
						alignItems="center"
						spacing={2}
						justifyContent="center"
						alignContent="center">
						<HomeIcon style={{ fontSize: '72px', color: theme.palette.primary.main }} />
						<ChatIcon
							style={{
								fontSize: '42px',
								color: theme.palette.primary.main, 
								backgroundColor: 'white', 
								position: 'relative', 
								top: '20px', 
								right: '34px', 
								zIndex: 1, // Ensure the ChatIcon is above the HomeIcon
							}}
						/>
					</Stack>
					<Typography variant="h5" gutterBottom>
						Synapcus Chatbot
					</Typography>					
					<br />
					</>
				}
            </Box>
        );
    }

	return (
		<Box
			ref={msgRef}
			sx={{
				height: props.height || '100dvh',
				maxHeight: '100dvh',
				width: '100%',
				boxSizing: 'border-box',
				display: 'flex',
				flexDirection: 'column',
				minHeight: 0,
				overflow: 'hidden'
			}}
		>
			{/*renderWelcomeHeader()*/}
			<Box sx={{ flex: '1 1 auto', minHeight: 0 }}>
				<MuiChat 
					chatController={chatController} 
					pendingStatus={pendingStatus}
					//actionRequest={waitingForResponse} 
					//messageClassName={classes.customMessage} 
					{...props}
					height="100%"
				/>
			</Box>
			{!isMobileViewport && !chatController.chatConfig?.isP2P &&
				<Box sx={{ flex: '0 0 auto', textAlign: 'center', px: 1, pb: 0.5 }}>
					<Typography variant="body3"
						style={{ 
							color: 'grey', 
							fontSize: 'smaller' 
						}}
					>{resolveChatUiLabels(props.supportLanguage, props.chatUiLabels).disclaimer}</Typography>
				</Box>
			}
		</Box>
	);
}

export { QeeMuiChat };
